import React from "react";
import { Link } from "react-router-dom";
import LegalPage, { Section, H2, H3, P, List } from "./components/LegalPage";
import { brand as ds } from "./designSystem";
import { ANBIETER, ANBIETER_EINZEILIG } from "./anbieter";

/* ════════════════════════════════════════════════════════════════════════
   AGB mit Widerrufsbelehrung.

   Die Widerrufsbelehrung folgt wörtlich dem gesetzlichen Muster (Anlage 1
   zu Art. 246a § 1 Abs. 2 S. 2 EGBGB, Fassung ab 19.06.2026, Gestaltungs-
   hinweise 3 und 6 für Dienstleistungen ausgefüllt). Nur bei wörtlicher
   Übernahme gilt die Belehrung als ordnungsgemäß — deshalb nicht umformulieren,
   auch wenn einzelne Sätze (Lieferkosten) bei einem Online-Dienst ins Leere
   gehen.

   ⚠ Der Text steht ein zweites Mal in schriftbot-backend/rechtstexte.js —
   für die Vertragsbestätigung per E-Mail. Bei jeder Änderung beide anpassen;
   src/AGB.test.js prüft, dass sie übereinstimmen.

   Bewusst NICHT enthalten: eine Änderungsklausel für Preise oder AGB. Einseitige
   Änderungen gegenüber Verbrauchern sind nur in engen Grenzen wirksam
   (BGH XI ZR 26/20); Bestandskunden behalten ihren Preis bis zur Kündigung.
   ════════════════════════════════════════════════════════════════════════ */

const Absatz = ({ n, children, last }) => (
  <P style={last ? { margin: 0 } : undefined}>
    ({n}) {children}
  </P>
);

export default function AGB() {
  return (
    <LegalPage title="Allgemeine Geschäftsbedingungen" updated="November 2026">
      <Section>
        <H2>§ 1 Geltungsbereich</H2>
        <Absatz n={1}>
          Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) gelten für
          alle Verträge über die Nutzung des Online-Dienstes Schriftbot unter{" "}
          {ANBIETER.website} zwischen {ANBIETER.inhaber}, handelnd unter der
          Geschäftsbezeichnung {ANBIETER.geschaeftsbezeichnung},{" "}
          {ANBIETER.strasse}, {ANBIETER.ort} (nachfolgend „Anbieter“), und dem
          Kunden.
        </Absatz>
        <Absatz n={2}>
          Verbraucher im Sinne dieser AGB ist jede natürliche Person, die ein
          Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer
          gewerblichen noch ihrer selbständigen beruflichen Tätigkeit
          zugerechnet werden können (§ 13 BGB).
        </Absatz>
        <Absatz n={3} last>
          Abweichende Bedingungen des Kunden werden nicht Vertragsbestandteil,
          es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich zu.
        </Absatz>
      </Section>

      <Section>
        <H2>§ 2 Leistungen des Anbieters</H2>
        <Absatz n={1}>
          Schriftbot ist ein webbasierter Dienst, mit dem der Kunde Texte als
          handschriftähnliches Schriftbild darstellen und als PDF-, Bild- oder
          GoodNotes-Datei herunterladen kann.
        </Absatz>
        <Absatz n={2}>
          Editor und Vorschau können ohne Abonnement unentgeltlich genutzt
          werden. Für das Herunterladen von Dateien ist ein Kundenkonto
          erforderlich. Der Anbieter kann angemeldeten Kunden ohne Abonnement
          eine begrenzte Zahl unentgeltlicher Downloads gewähren, etwa als
          Startguthaben oder im Austausch gegen in den Spielen gesammelte
          Münzen. Ein Anspruch auf unentgeltliche Leistungen besteht nicht.
        </Absatz>
        <Absatz n={3}>
          Kostenpflichtige Leistungen werden als Monatsabonnement in
          verschiedenen Tarifen angeboten. Der Leistungsumfang des jeweiligen
          Tarifs ergibt sich aus der Tarifbeschreibung auf der Website und der
          Bestellübersicht zum Zeitpunkt der Bestellung.
        </Absatz>
        <Absatz n={4}>
          Ein Download berechtigt zum einmaligen Erzeugen und Herunterladen
          einer Datei. Das Kontingent eines Tarifs gilt jeweils für einen
          Abrechnungsmonat; nicht genutzte Downloads werden nicht in den
          Folgemonat übertragen. Downloads sind an das Kundenkonto gebunden,
          nicht übertragbar und nicht in Geld auszahlbar.
        </Absatz>
        <Absatz n={5}>
          In Tarifen, die eine eigene Handschrift umfassen, kann der Kunde die
          Zeichen seiner Handschrift im Browser zeichnen. Der Anbieter erzeugt
          daraus eine Schrift, die der Kunde für die Dauer des Abonnements
          nutzen kann. Die Zeichnung bleibt im Kundenkonto gespeichert, bis der
          Kunde das Konto löscht, und steht bei einem erneuten Abschluss
          wieder zur Verfügung.
        </Absatz>
        <Absatz n={6}>
          Der Anbieter stellt während der Vertragslaufzeit die Aktualisierungen
          bereit, die für den Erhalt der Vertragsmäßigkeit erforderlich sind
          (§ 327f BGB).
        </Absatz>
        <Absatz n={7} last>
          Der Dienst steht grundsätzlich rund um die Uhr zur Verfügung.
          Vorübergehende Einschränkungen wegen Wartungsarbeiten, aus
          Sicherheitsgründen oder aufgrund von Störungen, die außerhalb des
          Einflussbereichs des Anbieters liegen, sind möglich. Die gesetzlichen
          Rechte des Kunden bleiben unberührt.
        </Absatz>
      </Section>

      <Section>
        <H2>§ 3 Vertragsschluss</H2>
        <Absatz n={1}>
          Die Darstellung der Tarife auf der Website stellt kein rechtlich
          bindendes Angebot dar, sondern eine Aufforderung zur Abgabe einer
          Bestellung.
        </Absatz>
        <Absatz n={2}>
          Der Kunde wählt einen Tarif und meldet sich mit seinem Google-Konto
          an. In der Bestellübersicht werden ihm Tarif, Preis, Laufzeit und
          Kündigungsbedingungen angezeigt. Über die Schaltfläche „Weiter zur
          Zahlung“ gelangt er auf die Bezahlseite des Zahlungsdienstleisters
          Stripe und gibt dort seine Zahlungsdaten ein. Durch Anklicken der
          Schaltfläche „Kostenpflichtig abonnieren“ gibt der Kunde ein
          verbindliches Angebot zum Abschluss des Abonnements ab.
        </Absatz>
        <Absatz n={3}>
          Bis zum Anklicken dieser Schaltfläche kann der Kunde seine Eingaben
          jederzeit berichtigen: Die Bestellübersicht lässt sich schließen und
          der Tarif neu wählen; auf der Bezahlseite können alle Eingaben
          geändert werden, und über den Zurück-Link gelangt der Kunde ohne
          Bestellung zurück zu Schriftbot.
        </Absatz>
        <Absatz n={4}>
          Der Vertrag kommt zustande, indem der Anbieter das Angebot durch
          Freischaltung des gewählten Tarifs im Kundenkonto annimmt. Der
          Anbieter bestätigt den Vertragsschluss per E-Mail.
        </Absatz>
        <Absatz n={5}>
          Der Anbieter speichert den Vertragstext. Der Kunde erhält die
          Vertragsdaten, diese AGB und die Widerrufsbelehrung per E-Mail. Die
          jeweils aktuelle Fassung der AGB ist jederzeit unter{" "}
          <Link to="/agb" className="sb-link">
            {ANBIETER.website}/agb
          </Link>{" "}
          abrufbar. Vertragssprache ist Deutsch.
        </Absatz>
        <Absatz n={6} last>
          Minderjährige können einen kostenpflichtigen Vertrag nur mit
          Einwilligung ihrer gesetzlichen Vertreter schließen (§§ 107, 108
          BGB).
        </Absatz>
      </Section>

      <Section>
        <H2>§ 4 Kostenlose Testphase</H2>
        <Absatz n={1}>
          Für einzelne Tarife kann der Anbieter eine kostenlose Testphase
          anbieten. Dauer und Leistungsumfang ergeben sich aus der
          Bestellübersicht. Für die Testphase ist die Angabe einer Zahlungsart
          erforderlich; eine Belastung erfolgt erst nach ihrem Ende. Jedes
          Kundenkonto kann die Testphase nur einmal nutzen.
        </Absatz>
        <Absatz n={2}>
          Kündigt der Kunde während der Testphase, endet der Vertrag mit Zugang
          der Kündigung. Ab diesem Zeitpunkt entfällt der Zugriff auf die
          kostenpflichtigen Funktionen; Kosten entstehen nicht.
        </Absatz>
        <Absatz n={3} last>
          Kündigt der Kunde nicht, geht die Testphase mit ihrem Ablauf in ein
          kostenpflichtiges Monatsabonnement zu dem in der Bestellübersicht
          genannten Preis über. Die erste Zahlung wird am Tag nach dem Ende der
          Testphase fällig.
        </Absatz>
      </Section>

      <Section>
        <H2>§ 5 Preise und Zahlung</H2>
        <Absatz n={1}>
          Es gelten die zum Zeitpunkt der Bestellung angegebenen Preise. Die
          Preise sind Endpreise. Als Kleinunternehmer im Sinne von § 19 UStG
          berechnet der Anbieter keine Umsatzsteuer und weist diese nicht aus.
        </Absatz>
        <Absatz n={2}>
          Das Entgelt ist monatlich im Voraus zu zahlen, erstmals mit
          Vertragsschluss beziehungsweise nach Ablauf der Testphase. Die
          Zahlungsabwicklung erfolgt über den Zahlungsdienstleister Stripe
          Payments Europe, Ltd., Dublin, Irland. Die verfügbaren Zahlungsarten
          werden auf der Bezahlseite angezeigt.
        </Absatz>
        <Absatz n={3} last>
          Schlägt eine Zahlung fehl, kann der Anbieter den Zugang zu den
          kostenpflichtigen Funktionen bis zum Ausgleich des fälligen Betrags
          aussetzen.
        </Absatz>
      </Section>

      <Section>
        <H2>§ 6 Laufzeit und Kündigung</H2>
        <Absatz n={1}>
          Das Abonnement hat eine Laufzeit von einem Monat und verlängert sich
          jeweils um einen weiteren Monat, wenn es nicht gekündigt wird.
        </Absatz>
        <Absatz n={2}>
          Der Kunde kann das Abonnement jederzeit ohne Angabe von Gründen
          kündigen. Die Kündigung wird zum Ende des laufenden
          Abrechnungsmonats wirksam; bis dahin bleibt der Zugang bestehen. Für
          die Testphase gilt § 4 Abs. 2.
        </Absatz>
        <Absatz n={3}>
          Die Kündigung kann über die Kündigungsschaltfläche unter{" "}
          <Link to="/kuendigen" className="sb-link">
            {ANBIETER.website}/kuendigen
          </Link>{" "}
          ohne Anmeldung (§ 312k BGB) oder in Textform, etwa per E-Mail an{" "}
          {ANBIETER.email}, erklärt werden. Der Anbieter bestätigt den Eingang
          der Kündigung unverzüglich in Textform.
        </Absatz>
        <Absatz n={4}>
          Das Recht beider Parteien zur außerordentlichen Kündigung aus
          wichtigem Grund bleibt unberührt. Ein wichtiger Grund liegt für den
          Anbieter insbesondere bei einem schwerwiegenden Verstoß gegen § 9
          vor.
        </Absatz>
        <Absatz n={5} last>
          Löscht der Kunde sein Kundenkonto, endet ein laufendes Abonnement
          mit sofortiger Wirkung. Eine anteilige Erstattung für den bereits
          bezahlten Abrechnungsmonat erfolgt in diesem Fall nicht; gesetzliche
          Ansprüche des Kunden bleiben unberührt.
        </Absatz>
      </Section>

      <Section id="widerruf">
        <H2 id="widerrufsbelehrung">§ 7 Widerrufsrecht für Verbraucher</H2>
        <P>
          Verbrauchern steht ein Widerrufsrecht nach Maßgabe der folgenden
          Belehrung zu.
        </P>

        <H3>Widerrufsbelehrung</H3>
        <P style={{ fontWeight: 600, margin: "0 0 8px" }}>Widerrufsrecht</P>
        <P>
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
          diesen Vertrag zu widerrufen.
        </P>
        <P>
          Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
          Vertragsschlusses.
        </P>
        <P>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns ({ANBIETER_EINZEILIG},
          E-Mail: {ANBIETER.email}) mittels einer eindeutigen Erklärung (z. B.
          ein mit der Post versandter Brief oder E-Mail) über Ihren Entschluss,
          diesen Vertrag zu widerrufen, informieren. Sie können dafür das
          beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht
          vorgeschrieben ist. Sie können Ihr Widerrufsrecht auch online unter{" "}
          <Link to="/widerruf" className="sb-link">
            {ANBIETER.website}/widerruf
          </Link>{" "}
          ausüben. Wenn Sie diese Online-Funktion nutzen, übermitteln wir Ihnen
          auf einem dauerhaften Datenträger (z. B. durch eine E-Mail)
          unverzüglich eine Eingangsbestätigung mit Informationen zum Inhalt
          der Widerrufserklärung sowie dem Datum und der Uhrzeit ihres
          Eingangs.
        </P>
        <P>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
          über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
          absenden.
        </P>

        <P style={{ fontWeight: 600, margin: "20px 0 8px" }}>
          Folgen des Widerrufs
        </P>
        <P>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
          die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit
          Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
          eine andere Art der Lieferung als die von uns angebotene, günstigste
          Standardlieferung gewählt haben), unverzüglich und spätestens binnen
          vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
          Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese
          Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der
          ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen
          wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
          Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </P>
        <P>
          Haben Sie verlangt, dass die Dienstleistungen während der
          Widerrufsfrist beginnen soll, so haben Sie uns einen angemessenen
          Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie
          uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags
          unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum
          Gesamtumfang der im Vertrag vorgesehenen Dienstleistungen entspricht.
        </P>
        <P muted>Ende der Widerrufsbelehrung</P>

        <H3>Muster-Widerrufsformular</H3>
        <P>
          (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses
          Formular aus und senden Sie es zurück.)
        </P>
        <p
          style={{
            fontFamily: ds.font.body,
            fontSize: 17,
            lineHeight: 1.65,
            color: ds.color.ink,
            whiteSpace: "pre-line",
            margin: 0,
          }}
        >
          {`– An ${ANBIETER_EINZEILIG}, E-Mail: ${ANBIETER.email}
– Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der folgenden Dienstleistung (*)
– Bestellt am (*)/erhalten am (*)
– Name des/der Verbraucher(s)
– Anschrift des/der Verbraucher(s)
– Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)
– Datum

(*) Unzutreffendes streichen.`}
        </p>
      </Section>

      <Section>
        <H2>§ 8 Gewährleistung</H2>
        <Absatz n={1}>
          Es gelten die gesetzlichen Vorschriften über Mängel digitaler
          Produkte (§§ 327d ff. BGB).
        </Absatz>
        <Absatz n={2} last>
          Beanstandungen und Beschwerden kann der Kunde an {ANBIETER.email}{" "}
          richten. Der Anbieter beantwortet sie in der Regel innerhalb von drei
          Werktagen.
        </Absatz>
      </Section>

      <Section>
        <H2>§ 9 Pflichten des Kunden und zulässige Nutzung</H2>
        <Absatz n={1}>
          Schriftbot ist ein Gestaltungswerkzeug für Notizen, Briefe, Karten,
          Einladungen, Lernunterlagen, Vorlagen, Entwürfe und vergleichbare
          Zwecke. Die erzeugten Dateien sind digitale Grafiken.
        </Absatz>
        <Absatz n={2}>Dem Kunden ist insbesondere untersagt,</Absatz>
        <List
          items={[
            "die Handschrift oder Unterschrift einer anderen Person ohne deren Einwilligung nachzubilden,",
            "Dokumente herzustellen oder zu verändern, um über ihren Aussteller oder ihre Echtheit zu täuschen, etwa Unterschriften, Entschuldigungen, Atteste, Zeugnisse, Verträge oder Ausweise (§§ 267 ff. StGB),",
            "erzeugte Texte entgegen schulischen, hochschulischen oder beruflichen Vorgaben als eigene Handschrift einzureichen, wo eine eigenhändige Niederschrift verlangt wird,",
            "rechtswidrige Inhalte zu erzeugen oder zu verbreiten,",
            "den Dienst automatisiert abzufragen oder technische Beschränkungen, insbesondere Download-Kontingente, zu umgehen.",
          ]}
        />
        <Absatz n={3}>
          Die Rechte an den eingegebenen Texten verbleiben beim Kunden. Die
          erzeugten Dateien darf der Kunde für eigene Zwecke verwenden, auch
          nach Ende des Vertrags. Für den Inhalt der Texte und die Art ihrer
          Verwendung ist allein der Kunde verantwortlich; ob eine Verwendung im
          Einzelfall zulässig ist, etwa nach schulischen Vorgaben, hat er
          selbst zu prüfen.
        </Absatz>
        <Absatz n={4} last>
          Bei einem Verstoß kann der Anbieter den Zugang sperren und den
          Vertrag nach § 6 Abs. 4 kündigen. Hinweise auf rechtswidrige Inhalte
          nimmt der Anbieter unter {ANBIETER.email} entgegen.
        </Absatz>
      </Section>

      <Section>
        <H2>§ 10 Haftung</H2>
        <Absatz n={1}>
          Der Anbieter haftet unbeschränkt bei Vorsatz und grober
          Fahrlässigkeit, für Schäden aus der Verletzung des Lebens, des
          Körpers oder der Gesundheit, nach dem Produkthaftungsgesetz sowie im
          Umfang einer übernommenen Garantie.
        </Absatz>
        <Absatz n={2}>
          Bei leicht fahrlässiger Verletzung einer wesentlichen Vertragspflicht
          ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden
          begrenzt. Wesentliche Vertragspflichten sind Pflichten, deren
          Erfüllung die ordnungsgemäße Durchführung des Vertrags überhaupt erst
          ermöglicht und auf deren Einhaltung der Kunde regelmäßig vertrauen
          darf.
        </Absatz>
        <Absatz n={3}>
          Im Übrigen ist die Haftung für leicht fahrlässig verursachte Schäden
          ausgeschlossen.
        </Absatz>
        <Absatz n={4} last>
          Die vorstehenden Beschränkungen gelten auch zugunsten der
          Erfüllungsgehilfen des Anbieters. Die gesetzlichen Mängelrechte nach
          § 8 bleiben unberührt.
        </Absatz>
      </Section>

      <Section>
        <H2>§ 11 Datenschutz</H2>
        <P style={{ margin: 0 }}>
          Informationen zur Verarbeitung personenbezogener Daten enthält die{" "}
          <Link to="/datenschutz" className="sb-link">
            Datenschutzerklärung
          </Link>
          .
        </P>
      </Section>

      <Section>
        <H2>§ 12 Streitbeilegung</H2>
        <P style={{ margin: 0 }}>
          Der Anbieter ist nicht bereit und nicht verpflichtet, an
          Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilzunehmen (§ 36 Abs. 1 Nr. 1 VSBG).
        </P>
      </Section>

      <Section>
        <H2>§ 13 Schlussbestimmungen</H2>
        <Absatz n={1}>
          Es gilt das Recht der Bundesrepublik Deutschland. Gegenüber
          Verbrauchern gilt diese Rechtswahl nur insoweit, als dadurch nicht
          der Schutz entzogen wird, der durch zwingende Bestimmungen des
          Rechts des Staates gewährt wird, in dem der Verbraucher seinen
          gewöhnlichen Aufenthalt hat.
        </Absatz>
        <Absatz n={2} last>
          Sind einzelne Bestimmungen dieser AGB unwirksam, bleibt der Vertrag
          im Übrigen wirksam (§ 306 BGB).
        </Absatz>
      </Section>
    </LegalPage>
  );
}
